import React, {
    useContext,
    useCallback,
    useMemo
} from 'react';
import { useHistory } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import { SgEndorsementSummaryInfo, CepConstants } from 'saga-cep-specific-components';
import { useSgTrackPageName, SgCepChanges } from 'saga-modules';
import { WizardPage } from 'gw-portals-wizard-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import SgCepLobSpecificUtil from 'sg-cep-lob-specific-util';
import SgOtherProducts from 'sg-other-products';
import SgMultiCarousel from 'sg-multi-carousel';
import CommonConstants from 'sg-common-constants';
import SgCepSideMenu from 'sg-cep-side-menu';
import metadata from './SgEndorsementConfirmationPage.metadata.json5';
import messages from './SgEndorsementConfirmationPage.messages';

function SgEndorsementConfirmationPage(props) {
    const {
        wizardData: modelVM
    } = props;

    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const history = useHistory();
    useSgTrackPageName(CepConstants.PAGE_NAMES.MTA_CONFIRMATION);
    const productCode = modelVM.baseData.productCode.value;
    const paymentPlanName = modelVM.paymentPlan.value;

    const isMonthly = useMemo(() => {
        return paymentPlanName === CommonConstants.PAYMENT_PLANS.MONTHLY
            || paymentPlanName === CommonConstants.PAYMENT_PLANS.MONTHLY_UPFRONT;
    }, [paymentPlanName]);

    const getTypelistValue = useCallback((value) => {
        const typelistValue = viewModelService.productMetadata.get('pc').types.getTypelist(value.typelist.name).getCode(value.code).name;
        return translator({ id: typelistValue, defaultMessage: typelistValue }).toString();
    }, [translator, viewModelService.productMetadata]);
    const changes = SgCepChanges.getMotorChanges(modelVM, getTypelistValue);

    const backToMainPage = useCallback(() => {
        history.push('/home');
    }, [history]);

    const carouselContent = useMemo(() => {
        return (
            <>
                <SgMultiCarousel
                    carouselSet={SgCepLobSpecificUtil.getCarouselArticles(false)}
                    product={SgCepLobSpecificUtil.getProductName(productCode)}
                />
            </>
        );
    }, [productCode]);

    const overrideProps = {
        confirmationHeader: {
            content: translator(messages.ConfirmationHeader, {
                policyHolder: modelVM.baseData.accountName.value,
                product: SgCepLobSpecificUtil.getProductName(productCode)
            })
        },
        endorsementSummaryInfo: {
            productInfo: translator(SgCepLobSpecificUtil.getProductSummaryInfoMessage(productCode),
                SgCepLobSpecificUtil.getProductSummaryInfoParameters(productCode, modelVM, translator)),
            paymentPlanName: modelVM.paymentPlan.value,
            transactionCost: modelVM.transactionCost.value,
            additionalPaymentInfo: modelVM.additionalPaymentInformation.value,
            changesAdded: SgCepLobSpecificUtil.getChangesAdded(productCode, changes, translator),
            changesRemoved: SgCepLobSpecificUtil.getChangesRemoved(productCode, changes)
        },
        carouselElement: {
            content: carouselContent
        },
        otherProductsInfo: {
            hideProducts: SgCepLobSpecificUtil.getProductsToHideInSagaOtherProducts(productCode)
        },
        abilityToPayInfo: {
            visible: SgCepLobSpecificUtil.showAbilityToPayInfo(productCode) && isMonthly
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            backToMainPage
        },
        resolveComponentMap: {
            SgEndorsementSummaryInfo,
            SgOtherProducts,
            SgMultiCarousel,
            SgCepSideMenu
        }
    };

    return (
        <WizardPage showPrevious={false} showNext={false}>
            {renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers)}
        </WizardPage>
    );
}

export default SgEndorsementConfirmationPage;
